import { Text, View } from '@gluestack-ui/themed'
import React, { FC } from 'react'
import { StyleSheet } from 'react-native'
import { iconFont } from '../../../services/Icon'
import { theme } from '../../../theme'

interface ValidationItemProps {
  validated: boolean
  text: string
}
export const ValidationItem: FC<ValidationItemProps> = ({ validated, text }) => {
  const IconComponent = iconFont('')

  return (
    <View style={styles.wrapper}>
      <IconComponent name={validated ? 'checkmark' : 'close'} color={validated ? theme.colors.green : theme.colors.red} size={24} />
      <Text style={validated ? styles.validated : styles.notValidated}>{text}</Text>
    </View>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
    gap: 4,
  },
  validated: {
    color: theme.colors.green,
  },
  notValidated: {
    color: theme.colors.red,
  },
})
